import SvgArrow from "../svg/SvgArrow";

export default function FaqItem({question, answer, onClick, isOpen}) {
    return (
        <div className="w-full max-w-4xl">
            <div
                className={`flex justify-between items-center gap-6 md:gap-4 shadow-faq bg-white ${!isOpen ? 'mouse-hover:bg-gray-50' : ''} py-5 md:py-7 px-5 md:px-10 rounded-6 cursor-pointer transition-all duration-200 ease-linear`}
                onClick={onClick}>
                <p className="text-lg" dangerouslySetInnerHTML={{__html: question}}/>
                <div>
                    <SvgArrow width={25}
                              className={`transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                              id="faq-item"
                    />
                </div>
            </div>
            <div className={`accordion accordion-0 ${isOpen ? 'accordion-open' : ''}`}>
                <p dangerouslySetInnerHTML={{__html: answer}}
                   className="faq-body pt-6 px-5 md:px-10 text-sm max-w-3xl leading-180"/>
            </div>
        </div>
    )
}
